<template>
  <div class="licevoischet__page">
    <div v-loading="loading">
      <div class="container-fluid table_container" v-show="!loading">
        <h2 class="page__title">
          <p class="mobile_back noprint" @click="back">
            <svg
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z" fill="#32AAA7" />
            </svg>
          </p>
          <!-- {{$t("Детализация лицевого счета")}}: {{agentData.id}} - {{agentData.name}} -->
        </h2>
        <p>
          <span class="licshet"
            >{{ $t('Состояние счета Предпринимателя') }}:
            <span :class="official_balance < 0 ? 'red' : ''"
              >{{ official_balance === null ? 0 : official_balance }} Р.</span
            ></span
          >
          <span class="licshet ml-5"
            >{{ $t('Состояние Бонусного счета') }}:
            <span :class="balance < 0 ? 'red' : ''"
              >{{ balance === null ? 0 : balance }} Р.</span
            ></span
          >
        </p>
        <p class="p-0 m-0 history_title" v-if="rangeDate[0] !== null && rangeDate.length > 0">
          {{ $t('Период от и до') }}
        </p>
        <div class="row">
          <div class="col-md-6">
            <date-picker
              v-model="rangeDate"
              range-separator=" - "
              range
              :editable="false"
              @change="getSelectedDataRange"
              format="DD.MM.YYYY"
              placeholder="дд.мм.гггг - дд.мм.гггг"
              value-type="YYYY-MM-DD"
              style="width: 100%"
            >
            </date-picker>
          </div>
        </div>
        <div class="row mobile_search noprint">
          <div class="col search__btn noprint" @click="toggleSearch">
            {{ $t('Фильтр') }} <span class="search_icons mobi"></span>
          </div>
        </div>
        <!-- <p class="exp_print noprint">
          <span class="mr-3">Печать</span>
          <span class="mr-3" @click="downloadPdf">{{ $t('Экспорт в pdf') }}</span>
          <span class="mr-3" @click="downloadXls">{{ $t('Экспорт в xlsx') }}</span>
        </p> -->
        <div class="row">
          <div class="col-3">
            <button class="btn_type_1" @click="showModal1 = true">Перевод на Бонусный счет</button>
          </div>
          <div class="col-3">
            <button class="btn_type_1" @click="showModal2 = true">Перевод другому партнеру</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col">
            <el-tag
              v-for="tag in tags"
              :key="tag.name"
              closable
              @close="handleClose($event, tag)"
              :type="tag.type"
              :disable-transitions="true"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </div>
        <h2 class="licevoischet__page__summ mt-2">
          <span class="mr-4">{{ $t('ОСТАТОК НА НАЧАЛО') }} = {{ rest.amount_beg | localInt }}</span>
          <span class="mr-4">{{ $t('ОСТАТОК НА КОНЕЦ') }} = {{ rest.amount_end | localInt }}</span>
        </h2>
        <h2 class="licevoischet__page__summ">
          <span class="mr-4">{{ $t('НАЧИСЛЕНИЕ') }} = {{ incomes | localInt }} </span>
          <span class="mr-4">{{ $t('СПИСАНИЕ') }} = {{ outcomes | localInt }} </span>
          <span class="mr-4">{{ $t('ИЗМЕНЕНИЕ') }} = {{ changes | localInt }} </span>
        </h2>
        <b-table
          :fields="fields"
          :items="entries"
          head-variant="light"
          responsive
          sticky-header
          outlined
        >
          <template #cell(amount)="data">
            <b class="text-info">{{ data.value }}</b>
          </template>
        </b-table>
      </div>
    </div>
    <footer class="container-fluid cust_modal">
      <div class="container-md">
        <div class="row desktop_search">
          <div class="col text-center search__btn" @click="toggleSearch" v-if="!searchActive">
            {{ $t('Фильтр') }} <span class="search_icons"></span>
          </div>
        </div>
        <div v-if="searchActive" class="organization__modal">
          <h3>
            {{ $t('Фильтр') }}
            <span class="close_btn" @click="searchActive = !searchActive"></span>
          </h3>
          <div class="row edit mt-4">
            <div class="col-sm-6 custom_input">
              <input type="text" name="operType" id="operType" required v-model="filter.operType" />
              <label for="operType">{{ $t('Тип операции') }}</label>
              <span class="clear_icon" @click="clearInput('operType')"></span>
            </div>
            <div class="col-sm-6 custom_input">
              <input type="text" name="comment" id="comment" required v-model="filter.comment" />
              <label for="comment">{{ $t('Комментарий') }}</label>
              <span class="clear_icon" @click="clearInput('comment')"></span>
            </div>
          </div>
          <div class="row edit">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <button
                :disabled="isDisabled"
                :class="`mr-2 update ${isDisabled ? 'disabled' : ''}`"
                @click="getData"
              >
                {{ $t('Показать') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <footer class="container-fluid cust_modal" v-if="showModal1">
      <div class="container">
        <h4 class="mt-4 modal_title">
          {{ $t('Перевод на Бонусный счет') }}
          <span class="close_btn" @click="showModal1 = false"></span>
        </h4>
        <div class="row">
          <div class="col-md-6 mt-4 custom_input">
            <input
              type="text"
              name="sum"
              id="sum"
              required
              v-model="sum"
              step="0.1"
              v-currency="{
                currency: null,
                valueAsInteger: false,
                distractionFree: false,
                allowNegative: false,
              }"
            />
            <label for="sum">
              {{ $t('Сумма') }}
            </label>
            <span class="clear_icon" @click="clearSum()"></span>
          </div>
          <div class="col-md-6 mt-4 custom_input">
            <input
              type="text"
              name="comm"
              id="comm"
              required
              v-model="comm"
            />
            <label for="comm">
              {{ $t('Комментарий') }}
            </label>
            <span class="clear_icon" @click="comm = ''"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-6">
            <button class="btn_type_1" :class="`btn_type_1 ${sum ? '' : 'disabled'}`" :disabled="!sum" @click="transToOffical">Перевести</button>
          </div>
        </div>
      </div>
    </footer>
    <footer class="container-fluid cust_modal" v-if="showModal2">
      <div class="container">
        <h4 class="mt-4 modal_title">
          {{ $t('Перевод другому партнеру') }}
          <span class="close_btn" @click="showModal2 = false"></span>
        </h4>
        <div class="row align-items-end">
          <div class="col-md-6 mt-4 custom_input">
            <input
              type="text"
              name="sum"
              id="sum"
              required
              v-model="sum2"
              step="0.1"
              v-currency="{
                currency: null,
                valueAsInteger: false,
                distractionFree: false,
                allowNegative: false,
              }"
            />
            <label for="sum">
              {{ $t('Сумма') }}
            </label>
            <span class="clear_icon" @click="sum2 = null"></span>
          </div>
            <div class="col-md-6 mt-4">
              <span v-if="state" class="custom_label">
                {{ $t('Партнер-получатель') }}
              </span>
              <el-autocomplete
                style="width: 100%"
                v-model="state"
                :fetch-suggestions="querySearchAsync"
                :placeholder="`${$t('Партнер-получатель')}`"
                clearable
                @clear="dd"
                @change="gg"
                @select="handleSelect"
              ></el-autocomplete>
            </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-4 custom_input">
            <input
              type="text"
              name="comm2"
              id="comm2"
              required
              v-model="comm2"
            />
            <label for="comm2">
              {{ $t('Комментарий') }}
            </label>
            <span class="clear_icon" @click="comm2 = ''"></span>
          </div>
          <div class="col-6">
            <button class="btn_type_1" :class="`btn_type_1 ${sum2 && state ? '' : 'disabled'}`" :disabled="sum2 && state === ''" @click="transToPartOfficial">Перевести</button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapActions, mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import backApi from '../assets/backApi';
import dateFormat from '../assets/localDateFunc';

export default {
  name: 'AccountDetail',
  components: { DatePicker },
  data() {
    return {
      comm: '',
      comm2: '',
      showModal1: false,
      showModal2: false,
      tags: [],
      state: '',
      agentData: {},
      loading: true,
      balance: null,
      official_balance: null,
      filter: {
        comment: null,
        operType: null,
      },
      rest: {},
      searchActive: false,
      lang: {
        monthBeforeYear: false,
      },
      sum: null,
      sum2: null,
      income: [],
      outcome: [],
      rangeDate: [
        this.$moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD'),
        this.$moment()
          .subtract(0, 'months')
          .endOf('month')
          .format('YYYY-MM-DD'),
      ],
      entries: [
        {
          dte: new Date(),
          income: 200,
          outcome: 200,
          account_type: '2',
          comm: '2',
        },
      ],
      selectedUser: {
        agent_name: '',
      },
      fields: [
        {
          key: 'dte',
          label: 'Дата операции',
          sortable: true,
          thStyle: {
            width: '150px',
            minWidth: '120px',
          },
          formatter(v) {
            return dateFormat(v);
          },
        },
        {
          key: 'income',
          label: 'Начисление',
          sortable: true,
          thStyle: {
            width: '200px',
            minWidth: '120px',
          },
          formatter(v) {
            if (v >= 0) {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            }
            return null;
          },
        },
        {
          key: 'outcome',
          label: 'Списание',
          sortable: true,
          thStyle: {
            width: '200px',
            minWidth: '120px',
          },
          formatter(v) {
            if (v <= 0) {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            }
            return null;
          },
        },
        {
          key: 'account_type',
          label: 'Тип операции',
          sortable: true,
        },
        {
          key: 'comm',
          label: 'Комментарий',
          sortable: true,
        },
      ],
    };
  },
  metaInfo() {
    this.setPageTitle(`${this.$t('Счет Предпринимателя')}`);
    return {
      title: `${this.$t('ЛК Партнера')} - ${this.$t('Счет Предпринимателя')} : ${
        this.agentData.id
      } - ${this.agentData.name}`,
    };
  },
  async mounted() {
    await backApi
      .get('/agent/profile')
      .then(Response => {
        this.agentData = Response.data;
        this.balance = Response.data.balance;
        this.official_balance = Response.data.official_balance;
      });
    await this.getData();
  },
  computed: {
    ...mapState('auth', ['self_agent_id']),
    isDisabled() {
      if (
        (this.filter.comment === null || this.filter.comment === '')
        && (this.filter.operType === null || this.filter.operType === '')
      ) {
        return true;
      }
      return false;
    },
    incomes() {
      let summ = 0;
      this.income.forEach(item => {
        summ += item.amount;
      });
      return summ.toFixed(2);
    },
    outcomes() {
      let summ = 0;
      this.outcome.forEach(item => {
        summ += item.amount;
      });
      return summ.toFixed(2);
    },
    changes() {
      let summ = 0;
      this.entries.forEach(item => {
        summ += item.amount;
      });
      return summ.toFixed(2);
    },
  },
  methods: {
    async getData() {
    await backApi
      .get('/agent/profile')
      .then(Response => {
        this.agentData = Response.data;
        this.balance = Response.data.balance;
        this.official_balance = Response.data.official_balance;
      });
      const data = {
        params: {
          beg_dte: this.rangeDate[0] ? this.rangeDate[0] : null,
          end_dte: this.rangeDate[1] ? this.rangeDate[1] : null,
          find_comm: this.filter.comment,
          find_type: this.filter.operType,
          i_idacc: 3,
        },
      };
      if (this.filter.operType !== null && this.filter.operType !== '') {
        const tag = this.tags.find(t => t.key === 'operType');
        if (tag) {
          tag.name = `Тип операции: ${this.filter.operType}`;
        } else {
          this.tags.push({ name: `Тип операции: ${this.filter.operType}`, key: 'operType' });
        }
      }
      if (this.filter.comment !== null && this.filter.comment !== '') {
        const tag = this.tags.find(t => t.key === 'comment');
        if (tag) {
          tag.name = `Комментарий: ${this.filter.comment}`;
        } else {
          this.tags.push({ name: `Комментарий: ${this.filter.comment}`, key: 'comment' });
        }
        data.params.comment = this.comment;
      }
      await backApi.get('agent/account-detail', data).then(Response => {
        this.entries = Response.data.entries;
        this.income = this.entries.filter(i => i.amount > 0);
        this.outcome = this.entries.filter(i => i.amount < 0);
        this.entries.forEach(i => {
          // eslint-disable-next-line no-param-reassign
          i.income = i.amount;
          // eslint-disable-next-line no-param-reassign
          i.outcome = i.amount;
        });
      });
      if (this.searchActive === true) {
        // eslint-disable-next-line no-unused-expressions
        this.searchActive = false;
      }
      await backApi.get(`/agent/official-account-rest/${this.agentData.id}`, {
            params: {
              beg_dte: this.rangeDate[0] ? this.rangeDate[0] : null,
              end_dte: this.rangeDate[1] ? this.rangeDate[1] : null,
            },
          })
          .then(Response => {
            this.rest = Response.data;
          });
      this.loading = false;
    },
    transToPartOfficial() {
      const params = {
        amount: Number(this.sum2.replace(/,/, '.').replace(/\s/g, '')),
        agent_to: this.selectedUser.agent_id,
        comm: this.comm2,
      };
      backApi
        .post('/agent/official-account-transfert', params)
        .then(async () => {
          this.sum2 = null;
          this.comm2 = '';
          this.state = '';
          this.showModal2 = false;
          await this.getData();
          this.showToast(
            `${this.$t('Перевод другому партнеру')}`,
            `${this.$t('Операция выполнена успешно')}!`,
            'success',
          );
        })
        .catch(error => {
          this.showToast(
            `${this.$t('Перевод другому партнеру')}`,
            `${this.$t(error.response.data.detail)}!`,
            'danger',
          );
        });
    },
    handleSelect(item) {
      this.selectedUser = item;
    },
    dd() {
      this.state = '';
      this.selectedUser = { agent_name: '' };
    },
    gg() {
      console.log(this.selectedUser);
      if (this.selectedUser.agent_name !== '') {
        this.state = `${this.selectedUser.agent_id}-${this.selectedUser.agent_name}`;
      } else {
        this.state = '';
      }
    },
    querySearchAsync(queryString, cb) {
      const qr = queryString === '' ? 'а' : queryString;
      backApi.get('/agent/official-account-list', { params: { find_str: qr } }).then(Response => {
        Response.data.entries.forEach(u => {
          // eslint-disable-next-line no-param-reassign
          u.value = `${u.agent_id}-${u.agent_name}`;
        });
        const newMass = Response.data.entries.filter(user => Number(user.agent_id) !== Number(this.self_agent_id));
        cb(newMass);
      });
    },
    ...mapActions('currentPage', ['setPageTitle']),
    clearDP() {},
    transToOffical() {
      const params = {
        amount: Number(this.sum.replace(/,/, '.').replace(/\s/g, '')),
        comm: this.comm,
      };
      backApi
        .post('/agent/transfert-to-official-account', params)
        .then(async () => {
          this.sum = null;
          this.comm = '';
          this.showModal1 = false;
          await this.getData();
          this.showToast(
            `${this.$t('Перевод на Бонусный счет')}`,
            `${this.$t('Операция выполнена успешно')}!`,
            'success',
          );
        })
        .catch(error => {
          this.showToast(
            `${this.$t('Перевод на Бонусный счет')}`,
            `${this.$t(error.response.data.detail)}!`,
            'danger',
          );
        });
    },
    clearSum() {
      this.sum = null;
    },
    showToast(title, message, status) {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      // Increment the toast count
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        h('strong', { class: 'mr-2' }, message),
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, title)],
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: status,
      });
    },
    downloadXls() {
      backApi
        .get('/agent/account-detail/excel', {
          params: {
            beg_dte: this.rangeDate[0] ? this.rangeDate[0] : null,
            end_dte: this.rangeDate[1] ? this.rangeDate[1] : null,
            find_comm: this.filter.comment,
            find_type: this.filter.operType,
          },
          responseType: 'blob',
        })
        .then(({ data }) => {
          const filename = `${this.$t('Движение по бонуснуму счету')}.xlsx`;
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    downloadPdf() {
      backApi
        .get('/agent/account-detail/pdf', {
          params: {
            beg_dte: this.rangeDate[0] ? this.rangeDate[0] : null,
            end_dte: this.rangeDate[1] ? this.rangeDate[1] : null,
            find_comm: this.filter.comment,
            find_type: this.filter.operType,
          },
          responseType: 'blob',
        })
        .then(({ data }) => {
          const filename = `${this.$t('Движение по бонуснуму счету')}.pdf`;
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    handleClose(event, tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      if (tag.key === 'operType') {
        this.filter.operType = null;
        this.getData();
      } else if (tag.key === 'comment') {
        this.filter.comment = null;
        this.getData();
      }
    },
    toggleSearch() {
      this.searchActive = !this.searchActive;
    },
    back() {
      const navEl = document.getElementsByClassName('router-link-exact-active router-link-active');
      $(navEl[0])
        .parent()
        .parent()
        .siblings()
        .addClass('active');
    },
    clearInput(name) {
      this.filter[name] = '';
    },
    getSelectedDataRange() {
      if (this.rangeDate.some(d => d === null)) {
        this.rangeDate = [
          this.$moment()
            .subtract(1, 'months')
            .startOf('month')
            .format('YYYY-MM-DD'),
          this.$moment()
            .subtract(0, 'months')
            .endOf('month')
            .format('YYYY-MM-DD'),
        ];
      }
      backApi
        .get('agent/account-detail', {
          params: {
            beg_dte: this.rangeDate[0] ? this.rangeDate[0] : null,
            end_dte: this.rangeDate[1] ? this.rangeDate[1] : null,
            find_comm: this.filter.comment,
            find_type: this.filter.operType,
            i_idacc: 3,
          },
        })
        .then(Response => {
          this.entries = Response.data.entries;
          this.income = this.entries.filter(i => i.amount > 0);
          this.outcome = this.entries.filter(i => i.amount < 0);
          this.entries.forEach(i => {
            // eslint-disable-next-line no-param-reassign
            i.income = i.amount;
            // eslint-disable-next-line no-param-reassign
            i.outcome = i.amount;
          });
        });
      backApi
        .get(`/agent/official-account-rest/${this.agentData.id}`, {
          params: {
            beg_dte: this.rangeDate[0] ? this.rangeDate[0] : null,
            end_dte: this.rangeDate[1] ? this.rangeDate[1] : null,
          },
        })
        .then(Response => {
          console.log(Response.data);
          // eslint-disable-next-line prefer-destructuring
          this.rest = Response.data;
        });
    },
  },
  watch: {
    searchActive() {
      if (this.searchActive) {
        this.showModal1 = false;
        this.showModal2 = false;
      }
    },
    showModal1() {
      if (this.showModal1) {
        this.searchActive = false;
        this.showModal2 = false;
      }
    },
    showModal2() {
      if (this.showModal2) {
        this.searchActive = false;
        this.showModal1 = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search_icons {
  position: relative;
  top: 5px;
  display: inline-block;
  width: 24px !important;
  height: 21px;
  background-image: url('../../public/icons/search.svg');
  background-size: contain;
  background-repeat: no-repeat;
  &.mobi {
    position: absolute;
    top: 20px;
    right: 15px;
  }
}
.licshet {
  // margin-left: 30px;
  font-size: 25px;
  position: relative;
  top: 10px;
  & span.red {
    color: #bd0a0a;
  }
}
.update {
  width: 100%;
}
.mobile_search {
  display: none;
}
.organization__modal {
  position: relative;
  // padding: 20px 0px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.licevoischet__page {
  &__summ {
    text-align: center;
    // font-family: 'Futura PT Book';
    // font-weight: 500;
    background-color: #dee2f3;
    font-size: 16px;
    padding: 10px 0px;
    // margin-bottom: 160px;
  }

  & .exp_print {
    span {
      color: #32aaa7;
      cursor: pointer;
    }
  }
}
@media (max-width: 768px) {
  .desktop_search {
    display: none;
  }
  .mobile_search {
    display: block;
    margin-top: -20px;
    margin-bottom: 20px;
  }
}
@media (max-width: 575px) {
  .custom_input {
    margin-top: 20px;
  }
  .licevoischet__page__summ {
    position: fixed;
    bottom: 50px;
    left: 0;
    right: 0;
    font-size: 12px !important;
    padding-left: 15px;
    padding-right: 15px;
    & span {
      display: inline;
    }
  }
  .search_icons {
    height: 25px;
  }
}
@media (max-width: 450px) {
  .licevoischet__page__summ {
    font-size: 16px;
    & span {
      margin-top: 10px;
    }
  }
  .licshet {
    display: block;
    font-size: 20px;
    margin-left: 0;
  }
}
.organization__modal {
  //   position: absolute;
  // padding: 60px;
  width: 100%;
  bottom: 0;

  & .edit {
    input {
      // margin-bottom: 20px;
    }
    button {
      margin-top: 20px;
      width: 100%;
      border: 0;
      padding: 5px 30px;
      font-size: 16px;
      &:nth-of-type(1) {
        background-color: #32aaa7;
        color: white;
      }
      &:nth-of-type(2) {
        background-color: white;
        color: #32aaa7;
        border: 2px solid #32aaa7;
      }
      &.disabled {
        color: #9a9a9a;
        background-color: #dee2f3;
      }
    }
  }
}
</style>
<style>
.mx-datepicker svg {
  color: #32aaa7;
}
.sr-only {
  display: none;
}
</style>
